import React, { SVGProps } from 'react'

import { cn } from 'utils/cn'

type IconProps = SVGProps<SVGSVGElement> & {
  className?: string
}

export const FlowIcon: React.FC<IconProps> = ({
  className,
  ...props
}) => (
  <svg
    className={cn('w-5', className)}
    viewBox="0 0 21 21"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g transform="translate(0,2)">
      <path d="M15.32 8H2.5V5C2.5 4.72 2.72 4.5 3 4.5H11.94C11.84 4.28 11.77 4.04 11.77 3.77C11.77 3.13 12.08 2.62 12.5 2.3V1.75C12.5 0.78 11.72 0 10.75 0H7.25C6.28 0 5.5 0.78 5.5 1.75V3H3C1.91 3 1 3.91 1 5V13C1 14.09 1.91 15 3 15H15C16.09 15 17 14.09 17 13V8.11C16.78 8.21 16.54 8.28 16.27 8.28C15.91 8.28 15.59 8.17 15.32 8.01V8ZM7 1.75C7 1.63 7.12 1.5 7.25 1.5H10.75C10.87 1.5 11 1.62 11 1.75V3H7V1.75ZM15.5 13C15.5 13.28 15.28 13.5 15 13.5H3C2.72 13.5 2.5 13.28 2.5 13V9.5H7V10C7 10.56 7.44 11 8 11H10C10.56 11 11 10.56 11 10V9.5H15.5V13Z" fill="currentColor" />
      <path d="M19.05 3.43002L17.27 2.77002L16.61 0.99002C16.55 0.87002 16.42 0.77002 16.27 0.77002C16.12 0.77002 15.99 0.86002 15.93 0.99002L15.27 2.77002L13.52 3.43002C13.36 3.49002 13.27 3.62002 13.27 3.77002C13.27 3.92002 13.36 4.05002 13.52 4.11002L15.27 4.77002L15.93 6.55002C15.99 6.67002 16.12 6.77002 16.27 6.77002C16.42 6.77002 16.55 6.68002 16.61 6.55002L17.27 4.77002L19.05 4.11002C19.17 4.05002 19.27 3.92002 19.27 3.77002C19.27 3.62002 19.18 3.49002 19.05 3.43002Z" fill="currentColor" />
    </g>
  </svg>
)
